export const PUSH_BANNER = () => 'PUSH_BANNER';
export const POP_BANNER = () => 'POP_BANNER';
